export default __webpack_public_path__ + "static/media/chrono-yellow.ebbd45a8.png";